import React from "react";
import { PropsWithChildren } from "react";

export type HeadingVariant = "primary" | "secondary" | "sub";

export interface HeadingProps extends PropsWithChildren<any> {
  variant?: HeadingVariant;
}

export const Heading = (props: HeadingProps) => {
  switch (props.variant) {
    case "sub":
      return <h3>{props.children}</h3>;
    case "secondary":
      return <h2>{props.children}</h2>;
    case "primary":
    default:
      return <h1>{props.children}</h1>;
  }
};
